import Lazyload from 'react-lazyload';
import PropTypes from 'prop-types';
import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';
import ReactPlayer from 'react-player';
import { Box, Text } from 'rebass';
import { StoryPageContext } from './StoryPage';
import useEntity from './hooks/useEntity';

const OuterBox = styled(Box)``;
const InnerBox = styled(Box)`
  ${OuterBox}:hover & {
    visibility: hidden;
  }
`;

const VideoMedium = ({ medium, height, captionTextId }) => {
  const { currentMedia, setCurrentMedia } = useContext(StoryPageContext);
  const captionText = useEntity({
    type: 'texts',
    id: captionTextId || '',
  });

  const text = useMemo(() => {
    if (!captionText.text) return '';
    return captionText.text.replace(/<[^>]*>?/gm, '');
  });

  return (
    <Lazyload height={height} offset={600} once>
      <OuterBox>
        <ReactPlayer
          url={medium['asset-url']}
          controls
          width="100%"
          height={height}
          playing={currentMedia === medium.id}
          onPlay={() => setCurrentMedia(medium.id)}
        />
        {text && (
          <InnerBox p={3} bg="photoGradientEnd" css="position: absolute; bottom: 0; width: 100%;">
            <Text
              color="white"
              css="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;"
            >
              {text}
            </Text>
          </InnerBox>
        )}
      </OuterBox>
    </Lazyload>
  );
};

VideoMedium.propTypes = {
  medium: PropTypes.shape({}).isRequired,
  height: PropTypes.number,
  captionTextId: PropTypes.string,
};

VideoMedium.defaultProps = {
  height: 100,
  captionTextId: '',
};

export default VideoMedium;
